import React, { useState, useEffect } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import phnIcon from "../../assets/icons/phnIcon.png";
import logo from "../../assets/images/logo.png";
import viewcart from "../../assets/icons/viewcart.png";
import styles from "./Home.module.css";
import { useAuth } from "../../context/auth";

import Footer from "../../components/Footer/Footer";

import banner from "../../assets/images/banner.png";
import girl from "../../assets/images/girl.png";
import gridImg from "../../assets/icons/gridImg.png";
import listImg from "../../assets/icons/listImg.png";
import searchicon from "../../assets/icons/searchicon.png";
import addcart from "../../assets/icons/addcart.png";

import chatboot from "../../assets/icons/chatboot.png";

const Home = () => {
  const MAIN_URL = process.env.REACT_APP_URL;

  // initial name and log out logic
  const { user = {} } = useAuth();
  const { LogoutUser } = useAuth();
  const token = localStorage.getItem("token");
  const getInitials = (name) => {
    if (name) {
      const words = name.split(" ");
      const initials = words.map((word) => word.charAt(0).toUpperCase());
      return initials.join("");
    }
    return "";
  };

  const [viewType, setViewType] = useState("grid");
  const handleViewTypeChange = (type) => {
    setViewType(type);
  };

  // feedback modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  // feedback validation
  const validateFeedback = () => {
    const newErrors = {};
    if (!feedbackType.trim()) {
      newErrors.feedbackType = "feedbackType or Number is required";
    }
    if (!feedbackMessage.trim()) {
      newErrors.feedbackMessage = "feedbackMessage is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (validateFeedback()) {
      try {
        const response = await axios.post(
          `${MAIN_URL}/api/feedback/submit`,
          {
            feedbackType,
            feedbackMessage,
          }
        );
        setLoading(false);

        toast.success("Feedback added Successful!", {
          position: "top-right",
          autoClose: 2000,
        });
        console.log(response.data);
      } catch (error) {
        setLoading(false);

        console.error("Error submitting feedback:", error);
      }
      closeModal();
    } else {
      toast.error("Please fill in all required fields.");
      setLoading(false);
    }
  };
  //  navbar modal
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // for geting the all products data
  const [viewproducts, setViewproducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/product/getAllProducts`
        );
        setViewproducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // APPLY FILTER LOGIC--------------------------
  const [filters, setFilters] = useState({
    color: "",
    productType: "",
    brand: "",
    price: "",
  });

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/product/getAllProducts`,
          {
            params: filters,
          }
        );
        setViewproducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, [filters]);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;

    if (value === "featured") {
      setFilters({ ...filters, [name]: "" });
    } else {
      setFilters({ ...filters, [name]: value });
    }
  };

  // SORTING PRODUCT
  const handleSortChange = async (event) => {
    const selectedSortOption = event.target.value;
    try {
      const response = await axios.get(
        `${MAIN_URL}/api/product/getAllProducts`,
        {
          params: { sort: selectedSortOption },
        }
      );
      setViewproducts(response.data);
    } catch (error) {
      console.error("Error fetching sorted products:", error);
    }
  };
  // SEARCH BAR

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };
  useEffect(() => {
    const searchProducts = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/product/searchProducts`,
          {
            params: { search: searchQuery },
          }
        );
        setViewproducts(response.data);
      } catch (error) {
        console.error("Error searching products:", error);
      }
    };

    searchProducts();
  }, [searchQuery]);

  // FEEDBACK SECTION
  const [feedbackType, setFeedbackType] = useState("");
  const [feedbackMessage, setFeedbackMessage] = useState("");

  const handleFeedbackTypeChange = (event) => {
    setFeedbackType(event.target.value);
  };

  const handleFeedbackMessageChange = (event) => {
    setFeedbackMessage(event.target.value);
  };

  const addToCart = async (product) => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      await axios.post(
        `${MAIN_URL}/api/cart/addToCart/${product._id}`,
        null,
        config
      );
      toast.success(`${product.productName} added to cart!`);
    } catch (error) {
      console.error("Error adding product to cart:", error);
      toast.error("Failed to add product to cart");
    }
  };

  // count the cart prodcts

  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const fetchCartItems = async () => {
      try {
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(
          `${MAIN_URL}/api/cart/getCartItems`,
          config
        );
        setCartItems(response.data.products);
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    fetchCartItems();
  }, []);

  const totalQuantity = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  return (
    <>
      <div className={styles.home}>
        {/* <Header /> */}
        <div className={styles.header}>
          <div className={styles.left}>
            <img src={phnIcon} alt="phn" />
            <p>912121131313</p>
          </div>
          <div className={styles.middle}>
            Get 50% off on selected items &nbsp; | &nbsp; Shop Now
          </div>
          {token ? (
            <div className={styles.right}></div>
          ) : (
            <div className={styles.right}>
              <NavLink to="/login">Login</NavLink> &nbsp;|&nbsp;
              <NavLink to="/signup">Sign up</NavLink>
            </div>
          )}
        </div>
        {/* <Navbar /> */}
        <div className={styles.navbar}>
          <div className={styles.left}>
            <div className={styles.logo}>
              <img src={logo} alt="" />
              <p>Musicart</p>
            </div>
            <div className={styles.page}>Home</div>
            <div className={styles.page}>
              <NavLink className={styles.navlink_page} to="/invoices">
                Invoice
              </NavLink>
            </div>
          </div>
          {token && (
            <div className={styles.right}>
              <div className={styles.viewcart}>
                <img src={viewcart} alt="cart" />
                <button className={styles.cart_btn}>
                  <NavLink
                    className={styles.navlink_page_cart_btn}
                    to="/viewcart"
                  >
                    view cart
                  </NavLink>
                </button>
                <p>{totalQuantity}</p>
              </div>

              <div className={styles.dropdown}>
                <button className={styles.initials} onClick={toggleDropdown}>
                  {getInitials(user.name)}
                </button>
                {isOpen && (
                  <div className={styles.dropdown_content}>
                    <div
                      className={styles.overlay_initials}
                      onClick={toggleDropdown}
                    ></div>
                    <div
                      className={styles.modal_initials}
                      onClick={toggleDropdown}
                    >
                      <span>{user.name}</span>
                      <div className={styles.line}></div>
                      <button onClick={LogoutUser}>Logout</button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* BANNER ///////////////////////////////// */}
        <div className={styles.home_mainContainer}>
          <div className={styles.banner_bar}>
            <img src={banner} className={styles.banner} alt="banner" />
            <p>
              Grab upto 50% off on <br />
              Selected headphones
            </p>
            <img src={girl} className={styles.girl} alt="girl" />
          </div>
          {/* SEARCH /////////////////////// */}
          <div className={styles.search_bar}>
            {/* <div > */}
            <label htmlFor="img">
              <img className={styles.search_img} src={searchicon} alt="" />
            </label>
            <input
              type="text"
              className={styles.search_input}
              placeholder="Search by Product Name"
              onChange={handleSearch}
            />
            {/* </div> */}
          </div>

          {/* FILTER BAR SECTION ////////////////////////////// */}
          <div className={styles.middle_bar}>
            {/* //// */}
            <div className={styles.grid_section}>
              <img
                src={gridImg}
                className={`${styles.gridImage} ${
                  viewType === "grid" ? styles.active : ""
                }`}
                alt="Grid View"
                onClick={() => handleViewTypeChange("grid")}
              />
              <img
                src={listImg}
                className={`${styles.listImage} ${
                  viewType === "list" ? styles.active : ""
                }`}
                alt="List View"
                onClick={() => handleViewTypeChange("list")}
              />
            </div>
            {/* //// */}

            <div className={styles.filter_bar}>
              {/* Filter by Headphone Type */}

              <div className={styles.filter_section}>
                <select
                  name="productType"
                  id="productType"
                  onChange={handleFilterChange}
                >
                  <option value="" disabled selected hidden>
                    Headphone type
                  </option>
                  <option value="featured">Featured</option>
                  <option value="in-ear headphone">In-ear headphone</option>
                  <option value="on-ear headphone">On-ear headphone</option>
                  <option value="over-ear headphone">Over-ear headphone</option>
                </select>
              </div>

              {/* Filter by Company/Brand */}
              <div className={styles.filter_section}>
                <select name="brand" id="brand" onChange={handleFilterChange}>
                  <option value="" disabled selected hidden>
                    Company
                  </option>
                  <option value="featured">Featured</option>

                  <option value="jbl">JBL</option>
                  <option value="sony">Sony</option>
                  <option value="boat">Boat</option>
                  <option value="Zebronics">Zebronics</option>
                  <option value="Marshall">Marshall</option>
                  <option value="Ptron">Ptron</option>
                </select>
              </div>

              {/* Filter by Color */}
              <div className={styles.filter_section}>
                <select name="color" id="color" onChange={handleFilterChange}>
                  <option value="" disabled selected hidden>
                    Colour
                  </option>
                  <option value="featured">Featured</option>

                  <option value="blue">Blue</option>
                  <option value="black">Black</option>
                  <option value="white">White</option>
                  <option value="brown">Brown</option>
                </select>
              </div>

              {/* Filter by Price */}
              <div className={styles.filter_section}>
                <select name="price" id="price" onChange={handleFilterChange}>
                  <option value="" disabled selected hidden>
                    Price
                  </option>
                  <option value="featured">Featured</option>
                  <option value="0-1000">₹0 - ₹1,000</option>
                  <option value="1000-10000">₹1,000 - ₹10,000</option>
                  <option value="10000-20000">₹10,000 - ₹20,000</option>
                </select>
              </div>
            </div>

            {/* Sort Options */}
            <div className={styles.right}>
              <div className={styles.filter_sorting_section}>
                <select id="sorting" onChange={handleSortChange}>
                  <option value="" disabled selected hidden>
                    Sort by:
                  </option>
                  <option value="Featured">Featured</option>
                  <option value="lowest">Price: Lowest</option>
                  <option value="highest">Price: Highest</option>
                  <option value="a-z">Name: (A-Z)</option>
                  <option value="z-a">Name: (Z-A)</option>
                </select>
              </div>
            </div>
          </div>
          {/* FILTER BAR SECTION ////////////////////////////// */}

          {/* PRODUCT DISPLAY SECTION */}
          <div className={styles.all_products}>
            {viewproducts.map((product) => (
              <div
                key={product._id}
                className={
                  viewType === "grid"
                    ? styles.product_grid
                    : styles.product_list
                }
              >
                <div className={styles.product_img_section}>
                  <div className={styles.product_img}>
                    <NavLink
                      to={`/singleproduct/${product._id}`}
                      key={product._id}
                    >
                      <img
                        src={product.imgUrl}
                        alt={viewproducts.productName}
                      />
                    </NavLink>
                  </div>
                  {token && (
                  <div
                    className={styles.addcart}
                    onClick={() => addToCart(product)}
                  >
                    <img src={addcart} alt="addcart" />
                  </div>
                  )}
                </div>
                <div className={styles.product_details}>
                  <p className={styles.product_name}>{product.productName}</p>
                  <p className={styles.product_price}>
                    Price - ₹ {product.price}
                  </p>
                  <p className={styles.product_color}>
                    {product.color} | <span> {product.productType}</span>
                  </p>
                  {viewType === "list" && (
                    <div className={styles.extra_details}>
                      <p className={styles.short_description}>
                        {product.shortDescription}
                      </p>
                      <button className={styles.details_button}>
                        <NavLink
                          className={styles.link_details_button}
                          to={`/singleproduct/${product._id}`}
                          key={product._id}
                        >
                          Details
                        </NavLink>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          {/* PRODUCT DISPLAY SECTION */}

          <div className={styles.chatboot_icon} onClick={openModal}>
            <img src={chatboot} alt="chatboot" />
          </div>
          {isModalOpen && (
            <div
              className={styles.modal_container}
              // onClick={handleOutsideClick}
            >
              <div className={styles.overlay} onClick={closeModal}></div>
              <div className={styles.modalContent}>
                <form className={styles.modal_form} onSubmit={handleSubmit}>
                  <div className={styles.feedeback_type}>
                    <label htmlFor="type">Types of feedback</label>
                    <select
                      id="feedback"
                      value={feedbackType}
                      onChange={handleFeedbackTypeChange}
                    >
                      <option value="" disabled selected hidden>
                        Choose the type
                      </option>
                      <option value="Bugs">Bugs</option>
                      <option value="Feedback">Feedback</option>
                      <option value="Query">Query</option>
                    </select>
                    <p className={styles.errors} hidden={loading}>
                      {errors.feedbackType}
                    </p>
                  </div>
                  <label htmlFor="">Feedback</label>
                  <textarea
                    id="feedbackMessage"
                    value={feedbackMessage}
                    onChange={handleFeedbackMessageChange}
                    cols="30"
                    rows="10"
                    placeholder="Type your feedback"
                  ></textarea>
                  <p className={styles.errors} hidden={loading}>
                    {errors.feedbackMessage}
                  </p>
                  <button type="submit" className={styles.feedback_btn}>
                    Submit
                  </button>
                </form>
              </div>
            </div>
          )}
          {/* </div> */}
        </div>
        <Footer />
      </div>
      <ToastContainer />
    </>
  );
};

export default Home;
